<template>
  <div class="overview">
    <div class="mianview">
      <view>
        <h1 @click="goMain()">各种有趣玩具集合</h1>
      </view>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
const route = useRouter();
const info_but = ref(false);
onMounted(() => {
  setTimeout(() => {
    info_but.value = false;
  }, 3000);
});

function goMain() {
  route.push({
    path: "/search",
  });
}
</script>
<style lang="less" scoped>
.overview {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #decc000f;

  .mianview {
    flex: 1;
  }
}
</style>
